export const PREFIX = window.prefix || '';
export const SEARCH_URL = `/${PREFIX}apps/search/do`;
export const SUGGEST_URL = `/${PREFIX}apps/search/suggest`;
export const NEWS_LIST_URL = `/${PREFIX}apps/list/news`;



// WEBPACK FOOTER //
// ../source/common/utils/api.js